
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { GlobalComponent } from "src/app/global-component";

import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { AccountStatus } from "src/app/core/models/members/user/user.model";
import { BoolEnum } from "src/app/core/enums/bool-enum";
import { TableUserFilter } from "./table-userlist-filter-config-enum";


export class UserListTableConfig extends TableConfigurationModel {


     constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "User List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },

            {
                dataFieldName: 'fullName',
                title: 'Name',
                sortable: new SortByValuesModel('firstName'),
                visible: 'true',
                order: 1,
                width: "200px",
                type: ColumnTypeEnum.PhotoModel,
                subDataFieldName: 'roles',
                underTextDataFieldName: 'roles'
            },

            {
                dataFieldName: 'email',
                title: 'Email',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 2,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'phoneNumber',
                title: 'Phone Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 3,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'businessUnit',
                title: 'Tenant',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 4,
                width: "125px",
                type: ColumnTypeEnum.SubModel,
                subDataFieldName:'name',
            },
            {
                dataFieldName: 'status',
                title: 'Status',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 5,
                width: "100px",
                type: ColumnTypeEnum.Status,
            },
            {
                dataFieldName: 'enabled',
                title: 'Enabled',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 6,
                width: "100px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: `${BoolEnum.True}`, return: 'coloredTextArea green' },
                        { case: `${BoolEnum.False}`, return: 'coloredTextArea red' },
                        { case: undefined, return: 'coloredTextArea red' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: `${BoolEnum.True}`, return: 'True' },
                        { case: `${BoolEnum.False}`, return: 'False' },
                        { case: undefined, return: 'Unknown' }
                    ]
                }
            },
            {
                dataFieldName: 'lastActive',
                title: 'Last Seen',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 7,
                width: "120px",
                type: ColumnTypeEnum.LastActive,
            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Created',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 8,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
        
            {
                title: 'Actions',
                visible: 'true',
                order: 9,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [
            {
                label: TableUserFilter.UserStatusFilter,
                options: [  
                    new NgSelectListModel(undefined, $localize`:@@:All`,$localize`:@@:All`,undefined, true ),
                    new NgSelectListModel(`${AccountStatus.Approved}`, $localize`:@@:Approved`, undefined, "bx bx-check-circle" ),
                    new NgSelectListModel(`${AccountStatus.Disabled}`, $localize`:@@:Disabled`, undefined, "bx bx-error-alt" ),
                    new NgSelectListModel(`${AccountStatus.Onboarding}`, $localize`:@@:Onboarding`, undefined, "bx bx-folder-plus"  ),
                    new NgSelectListModel(`${AccountStatus.Pending}`, $localize`:@@:Pending`, undefined, "bx bx-time-five" ),
                    new NgSelectListModel(`${AccountStatus.PasswordReset}`, $localize`:@@:Password Reset`, undefined, "bx bx-reset" ),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: true,
                inButton: false,
            },
            {
                label: undefined,
                options: [  
                    new NgSelectListModel(undefined, undefined,undefined,undefined, true ),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: false,
                inButton: false,
            },
            {
                label: TableUserFilter.UserEnabledFilter,
                options: [  
                    new NgSelectListModel(undefined, $localize`:@@: All`,$localize`:@@: All`,undefined, true ),
                    new NgSelectListModel(`${BoolEnum.True}`, $localize`:@@: Enabled`),
                    new NgSelectListModel(`${BoolEnum.False}`, $localize`:@@: Disabled`),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]

        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search for contact number, name, company name, or email"
        }

        this.actions = [
            {   
                visible: SecurityOperations.user.userManagement,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true
            },
            {
                visible: SecurityOperations.security.authorizationContextUpdate,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },
            {
                visible: SecurityOperations.security.authorizationContextUpdate,
                label: 'Security',
                actionId: ActionIdEnum.Security,
                icon: 'ri-lock-2-fill',
                inDropdown: true,
                inList: false
            },
        ]
        this.buttons = [
            {
                visible: SecurityOperations.user.userCreate,
                label: "Invite",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.Invite,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },
            {
                visible: SecurityOperations.user.userCreate,
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },

            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text:  $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    }
                    
                ]
            },
            {
                visible: 'true',
                label: undefined,
                action: ButtonIdEnum.None,
                color: "btn-soft-secondary",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: 'Enable',
                        value: `${ButtonIdEnum.Enable}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text: 'Disable',
                        value: `${ButtonIdEnum.Disable}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                ]
            }
        ]
    }
}